import { registerPlugin } from '@capacitor/core';

import type { ReportFileExporterPlugin } from './definitions';

const ReportFileExporter = registerPlugin<ReportFileExporterPlugin>('ReportFileExporter', {
  web: () => import('./web').then(m => new m.ReportFileExporterWeb()),
});

export * from './definitions';
export { ReportFileExporter };
